
define(
	'Tavanoteam.TavanoTeam_CMS_Areas_Manager_Extension.BaseModule'
	, [
		'Handlebars'
	]
	, function (
		Handlebars
	) {

		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var environment = container.getComponent("Environment");

				var prefix = environment.getConfig('tavanoTeamCMSAreasManagerExtension.prefix');

				Handlebars.registerHelper('cmsAreaPrefix', function () {

					return prefix;
				});
			}
		};
	}
);
